import { REVIEW_ANNOTATION_TYPE } from '../constants';
import type { ReviewAnnotationsT } from '../types';
export const ANNOTATIONS: ReviewAnnotationsT = {
  '6c8538ec-0d23-4224-9973-47dfa5b03084': {
    type: REVIEW_ANNOTATION_TYPE.ANNOTATION,
    name: 'Car [1]',
    label: 'Car',
    attributes: [{
      classificationAttributes: [{
        question: 'What is the color of the car?',
        answers: ['Gray']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }, {
        question: 'Can you see the car completely? If yes, What is the color of the car?',
        answers: ['Yes, the car is completely visible. And the color of the car is gray.']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Moving',
        value: '1 -> 30'
      }, {
        key: 'Stationary',
        value: '31 -> 60'
      }]
    }, {
      classificationAttributes: [{
        question: 'Can you see the car completely? If yes, What is the color of the car?',
        answers: ['Yes, the car is completely visible. And the color of the car is gray.']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Stationary',
        value: '80 -> 95'
      }, {
        key: 'Moving',
        value: '96 -> 120'
      }]
    }, {
      classificationAttributes: [{
        question: 'What is the color of the car?',
        answers: ['Gray']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Moving',
        value: '130 -> 145'
      }, {
        key: 'Stationary',
        value: '146 -> 150'
      }]
    }],
    instances: [{
      key: 'Frame',
      startIndex: 0,
      endIndex: 60
    }, {
      key: 'Frame',
      startIndex: 80,
      endIndex: 120
    }, {
      key: 'Frame',
      startIndex: 130,
      endIndex: 150
    }]
  },
  '164492d8-89bf-45ee-bb52-c5e9a3cc05e6': {
    type: REVIEW_ANNOTATION_TYPE.CLASSIFICATION,
    name: 'Task Classification',
    label: 'Classification',
    attributes: [{
      classificationAttributes: [{
        question: 'What is the weather in the video ?',
        answers: ['Sunny']
      }, {
        question: 'What mode of transport is being used ?',
        answers: ['Roadways']
      }, {
        question: 'Optional Question',
        answers: []
      }]
    }]
  },
  '6c8538ec-0d23-4224-9973-47dfa5b03085': {
    type: REVIEW_ANNOTATION_TYPE.ANNOTATION,
    name: 'Car [2]',
    label: 'Car',
    attributes: [{
      classificationAttributes: [{
        question: 'What is the color of the car?',
        answers: ['Gray']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Moving',
        value: '1 -> 30'
      }, {
        key: 'Stationary',
        value: '31 -> 60'
      }]
    }, {
      classificationAttributes: [{
        question: 'Can you see the car completely? If yes, What is the color of the car?',
        answers: ['Yes, the car is completely visible. And the color of the car is gray.']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Stationary',
        value: '80 -> 95'
      }, {
        key: 'Moving',
        value: '96 -> 120'
      }]
    }, {
      classificationAttributes: [{
        question: 'What is the color of the car?',
        answers: ['Gray']
      }, {
        question: 'What is the make of the car?',
        answers: ['BMW']
      }],
      dynamicAttributes: [{
        key: 'Moving',
        value: '130 -> 145'
      }, {
        key: 'Stationary',
        value: '146 -> 150'
      }]
    }],
    instances: [{
      key: 'Frame',
      startIndex: 0,
      endIndex: 60
    }, {
      key: 'Frame',
      startIndex: 80,
      endIndex: 120
    }, {
      key: 'Frame',
      startIndex: 130,
      endIndex: 150
    }]
  },
  'c470b2a6-65cc-41c7-a7dd-5285fce65cf8': {
    type: REVIEW_ANNOTATION_TYPE.ANNOTATION,
    name: 'Truck [1]',
    label: 'Truck',
    attributes: [],
    instances: []
  },
  'cadec3fe-1f70-430f-ad5b-7b332cd51338': {
    type: REVIEW_ANNOTATION_TYPE.ANNOTATION,
    name: 'Frame Classification',
    label: 'Classification',
    attributes: [{
      classificationAttributes: [{
        question: 'Is there a vehicle between frame 10-20 ?',
        answers: ['Yes']
      }]
    }, {
      classificationAttributes: [{
        question: 'How many police cars are there between frame 50-200 ?',
        answers: ['6']
      }]
    }],
    instances: [{
      key: 'Frame',
      startIndex: 10,
      endIndex: 20
    }, {
      key: 'Frame',
      startIndex: 50,
      endIndex: 200
    }]
  }
};